import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {RequestService} from "projects/store/src/app/services/api/v1/request.service";
import {CustomMessageService, LocalStorageService, ResponseHttpError, UtilService} from "library";
import {HttpStatusCode} from "@angular/common/http";
import {ActivatedRoute} from "@angular/router";
import {EnrollmentStatus, LocalStorageKey, SalesWorkflowSteps} from "projects/store/src/app/enums";
import type {PhoneEnrollmentCompletedEvent, PhoneEnrollmentContext} from "@krediya/enrollment";

const PhoneEnrollmentCompletedCode = {
  Completed: 'COMPLETED',
  BackToImei: 'BACK_TO_IMEI',
} as const;

@Component({
  selector: 'app-sales-phone-enrollment',
  templateUrl: './sales-phone-enrollment.component.html'
})
export class SalesPhoneEnrollmentComponent implements OnInit {
  requestId: string;
  request: any = {};
  isEnrollmentEngine = false;
  step!: string;
  phoneEnrollmentData: any;
  enrollmentLibraryContext?: PhoneEnrollmentContext;
  message!: string;
  @Output() nextStepEvent = new EventEmitter<void>();
  @Output() gotoStepEvent = new EventEmitter<any>();

  constructor(private requestService: RequestService,
              private route: ActivatedRoute,
              private customMessageService: CustomMessageService,
              private utilService: UtilService,
              private localStorageService: LocalStorageService) {
    this.requestId = this.route.snapshot.params['request_id'];
    this.request = this.requestService.request;
  }

  ngOnInit() {
    const phoneEnrollmentFlowContext = this.localStorageService.get(LocalStorageKey.phoneEnrollmentFlowContext);

    if (phoneEnrollmentFlowContext?.type === EnrollmentStatus.engine && phoneEnrollmentFlowContext.enrollmentId) {
      this.isEnrollmentEngine = true;
      this.enrollmentLibraryContext = {
        enrollmentId: phoneEnrollmentFlowContext.enrollmentId,
        platform: 'trustonic'
      };
    } else {
      this.load();
    }
  }

  load() {
    this.utilService.enablePageLoading();
    this.requestService.getEnrollmentData(this.requestId).subscribe({
      next: (resp)=>{
        if(resp.status === HttpStatusCode.Ok) {
          if( resp.body.data.knox){
            this.step = 'init-enrollment-knox';
          }
          if( resp.body.data.nuovo){
            if(this.request.phone_platform.includes('datacultr')){
              this.step = 'init-enrollment-datacultr';
            }else{
              this.step = 'init-enrollment-nuovo';
            }
          }
          if( resp.body.data.trustonic){
            this.step = 'init-enrollment-trustonic';
          }
          this.phoneEnrollmentData = resp.body.data;
        }else{
          this.customMessageService.responseNoticeHandler(resp);
        }
        this.utilService.disablePageLoading();
      },
      error: (error: ResponseHttpError)=>{
        this.customMessageService.responseNoticeHandler(error);
        this.utilService.disablePageLoading();
      },
    })

  }

  onNextStep() {
    this.nextStepEvent.emit();
  }

  onEnrollmentLibraryCompleted(event: PhoneEnrollmentCompletedEvent) {
    if (event.code === PhoneEnrollmentCompletedCode.BackToImei) {
      this.onGotoStep({ stepCode: SalesWorkflowSteps['phone-register'] });
      return;
    }

    if (event.code !== PhoneEnrollmentCompletedCode.Completed || !event.context?.enrollmentId) {
      return;
    }

    const enrollmentId = event.context.enrollmentId;

    this.requestService.getEnrollmentEngineResult(this.requestId, enrollmentId).subscribe({
      next: (resp) => {
        if (resp.status === HttpStatusCode.Ok) {
          this.localStorageService.remove(LocalStorageKey.phoneEnrollmentFlowContext);
          this.onNextStep();
        } else {
          this.customMessageService.responseNoticeHandler(resp);
        }
      },
      error: (error: ResponseHttpError) => {
        this.customMessageService.responseNoticeHandler(error);
      }
    });
  }

  onStep(step: string) {
    this.step = step;
  }

  onGotoStep(event: any) {
    this.gotoStepEvent.emit(event);
  }

  onError(message: string) {
    this.message = message;
  }

}
